<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="flex-item" *ngIf="reqst===2">
    <div class="graphic">
        <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"  style="width: 100%; height: 80vh; display: block;"></highcharts-chart>
    </div>
</div>